import classNames from 'classnames';

import s from './PrimaryMetricsLayout.module.css';

/**
 * Shared layout component for primary metrics display.
 * Handles the common structure of two metrics with a divider between them.
 */
export const PrimaryMetricsLayout = ({
  isAccordionOpen,
  scoreMetricContent,
  activitiesMetricContent,
  showDivider = true,
  dividerHeightClass,
  containerClassName,
  isUngraded = false,
}) => {
  return (
    <div
      className={classNames(
        {
          [s.primaryMetricsContainer]: !isUngraded,
          [s.singleMetricContainer]: isUngraded,
          [s.openPadding]: isAccordionOpen,
        },
        containerClassName,
      )}
    >
      {!isUngraded && (
        <div
          className={classNames(s.total, {
            [s.openPositioning]: isAccordionOpen,
            [s.closedPositioning]: !isAccordionOpen,
          })}
        >
          {scoreMetricContent}
        </div>
      )}
      {!isUngraded && showDivider && (
        <hr
          className={classNames(
            s.divider,
            dividerHeightClass || s.dividerSlice2,
            {
              [s.closedSpacing]: !isAccordionOpen,
            },
          )}
        />
      )}
      <div
        className={classNames(s.total, {
          [s.openPositioning]: isAccordionOpen,
          [s.closedPositioning]: !isAccordionOpen,
        })}
      >
        {activitiesMetricContent}
      </div>
      {isUngraded && <div />}
    </div>
  );
};
